/* ============
 * Actions for the vivemas module
 * ============
 *
 * The actions that are available on the
 * vivemas module.
 */
import axios from 'axios'

export default {
  getBenefitsCategories ({ dispatch }) {
    let api = process.env.API_VIVEMAS + '/categories/benefits'
    return new Promise((resolve, reject) => {
      dispatch('checkJWT').then(() => {
        axios.get(api, {  headers: { 'Authorization': '' }, data: {}  })
          .then(res => {
            resolve(res)
          })
          .catch(err => {
            reject(err)
          })
        })
    })
  },
  getAssistsCategories ({ dispatch }) {
    let api = process.env.API_VIVEMAS + '/categories/assists'
    return new Promise((resolve, reject) => {
      dispatch('checkJWT').then(() => {
        axios.get(api)
          .then(res => {
            resolve(res)
          })
          .catch(err => {
            reject(err)
          })
        })
    })
  },
  getBenefits ({ commit, dispatch }) {
    
    let api = process.env.API_VIVEMAS + '/benefits'
    return new Promise((resolve, reject) => {
      
        axios.get(api, { params })
          .then(res => {
            
            if (res.data.code === '01') {
              commit('vivemas/setBenefits', res.data.data.rows, { root: true })
            }
            resolve(res)
          })
          .catch(err => {
            reject(err)
          })
    })
  },
  getAssists ({ commit, dispatch }) {
    let api = process.env.API_VIVEMAS + '/assists'
    return new Promise((resolve, reject) => {
        axios.get(api)
          .then(res => {
            if (res.data.code === '01') {
              commit('vivemas/setAssists', res.data.data.rows, { root: true })
            }
            resolve(res)
          })
          .catch(err => {
            reject(err)
          })
    })
  },
  getBrands ({ commit, dispatch }) {
    let api = process.env.API_VIVEMAS + '/brands'
    return new Promise((resolve, reject) => {
        axios.get(api)
          .then(res => {
            if (res.data.code === '01') {
              commit('vivemas/setBrands', res.data.data, { root: true })
            }
            resolve(res)
          })
          .catch(err => {
            reject(err)
          })
    })
  },
  editFavorite ({ dispatch }, option) {
    // let api = process.env.API_VIVEMAS + '/favorite/' + option
    return new Promise((resolve, reject) => {
      resolve({})
      /*
      dispatch('checkJWT').then(() => {
        axios.put(api, item)
          .then(res => {
            resolve(res)
          })
          .catch(err => {
            reject(err)
          })
      })
      */
    })
  },
  // Delegado en la sesión de CR Auth (user/ensureSession); nunca rechaza, igual que antes
  checkJWT ({ dispatch }) {
    return dispatch('user/checkJWT', null, { root: true })
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/vivemas/actions.js